import qs from 'qs'
import { post,ajaxParam } from '@/units/request.js'
export default {
	data(){
		return {
			logoTitle: ''
		}
	},
	methods: {
		//获取配置logo标题
		async getConfigData(){
			let param = {
				code: 'CT_TITLE'
			}
			ajaxParam(param)
			const res = await post('v1/sysConfig/getConfigByCode', qs.stringify(param))
			if(res.data.code==200){
				this.logoTitle = res.data.entity.configValue || ''
			} else {
			this.$message.error(res.data.msg)
			}
		}
	}
}